import React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { TextField } from '@/ui/form/controls/TextField'
import { useCertificateStore } from '@/modules/drivers/stores/certificateStore'
import OptionField from '@/ui/form/controls/OptionField'
import { AttestationDateMode } from '@/app/constants/attestationDateMode'
import {
  faCalendarPlusSolid,
  faClockThreeThirtySolid,
  FaIcon,
  faCalendarLinesPenRegular,
  faCalendarLinesPenSolid,
  faCalendarPlusRegular,
  faCalendarDayRegular,
  faCalendarDaySolid,
} from '@/lib/fa'
const DATE_MODE = [
  {
    mode: AttestationDateMode.AttestationDate,
    iconRegular: faCalendarDayRegular,
    iconSolid: faCalendarDaySolid,
  },
  {
    mode: AttestationDateMode.AttestationDateAfter,
    iconRegular: faCalendarLinesPenRegular,
    iconSolid: faCalendarLinesPenSolid,
  },
  {
    mode: AttestationDateMode.ExactDate,
    iconRegular: faCalendarPlusRegular,
    iconSolid: faCalendarPlusSolid,
  },
]
const CertificateReception = () => {
  const { t } = useLocalize()
  const { data, setData } = useCertificateStore()
  return (
    <div className="tw-flex tw-gap-4">
      <div className="tw-w-full tw-max-w-[200px] tw-space-y-2">
        <div className="tw-jusit tw-flex tw-flex-1 tw-items-center tw-gap-2 tw-font-medium tw-text-content-base">
          <FaIcon icon={faClockThreeThirtySolid} className="tw-max-w-[12px]" />
          <p className="tw-text-sm tw-font-semibold tw-text-content-base">
            Odbiór
          </p>
        </div>
      </div>
      <div className="tw-space-y-2  tw-w-full">
        <TextField
          label="Miejsce odbioru"
          placeholder={t('common.type')}
          name="name"
          value={data?.acceptedPlace}
          onChange={(e) => setData({ ...data, acceptedPlace: e.target.value })}
        />
        <div className="tw-space-y-1">
          <label className="tw-m-0 tw-text-sm tw-font-medium tw-text-content-base">
            Data odbioru
          </label>
          <div className="tw-flex tw-gap-2">
            {DATE_MODE.map(({ mode, iconRegular, iconSolid }) => (
              <OptionField
                key={mode}
                isSelected={data?.acceptedDateType === mode}
                iconRegular={iconRegular}
                iconSolid={iconSolid}
                onClick={() => {
                  setData({
                    ...data,
                    acceptedDateType: mode,
                  })
                }}
                label={t(`attestationForm.${AttestationDateMode[mode]}`)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CertificateReception
